export default "__VITE_ASSET__DlY1xkQ___"